import script from "./AcceptedRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./AcceptedRequest.vue?vue&type=script&setup=true&lang=js"

import "./AcceptedRequest.vue?vue&type=style&index=0&id=29258286&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29258286"]])

export default __exports__